import {FormioBase} from "./formiobase";

export class MyEcoActivity extends FormioBase {
  public inputType = "myecoactivity";
  public title = "Economic activity";
  public icon = "fa fa-certificate";
  public systemCodes = ["SV"];
  public shouldBeRenderedByFormio = false;
  public toHtml() {
      return '<div class="control-label ' +
        (this.isRequired() ? "field-required" : "") + '">' + this.title +
        '</div><div class="btn btn-primary">Choose</div>';
  }
  public schema: any = {
    title: "Economic activity",
    components: [{
      input: true,
      tree: true,
      message_key: "",
      dataUrl: "",
      tableView: true,
      label: "Economic activity",
      key: undefined,
      protected: false,
      persistent: true,
      validate: {
        required: false,
        max: 99999999,
        min: 0,
        custom: "",
      },
      clearOnHide: true,
      type: "myecoactivity",
      inputType: "myecoactivity",
      tags: [],
      customClass: "ds-myecoactivity",
    }],
  };
}
